import React from 'react';

const Team = () => {
    return (
        <>
            {/* Team Start */}
            <section className="container-xxl py-5 fundisha-marketing-section" style={{ paddingTop: 'calc(var(--af-nav-height) + 2.2rem)' }}>
                <div className="container">
                    <div className="fundisha-section-header text-center wow fadeInUp" data-wow-delay="0.1s">
                        <p className="fundisha-section-title">Instructors</p>
                        <h1 className="mb-5">Expert Instructors</h1>
                    </div>
                    <div className="row g-4">
                        <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                            <div className="team-item bg-light">
                                <div className="overflow-hidden">
                                    <img className="img-fluid" src="/img/Me.jpeg" alt="Team member 1" />
                                </div>
                                <div className="position-relative d-flex justify-content-center" style={{marginTop: "-23px"}}>
                                    <div className="bg-light d-flex justify-content-center pt-2 px-1">
                                       
                                        <a className="btn btn-sm-square btn-primary mx-1" href="https://www.linkedin.com/in/david-busuru-86a046201/"><i className="fab fa-linkedin"></i></a>
                                        <a className="btn btn-sm-square btn-primary mx-1" href="https://github.com/DBusuru"><i className="fab fa-github"></i></a>
                                    </div>
                                </div>
                                <div className="text-center p-4">
                                    <h5 className="mb-0">David Busuru</h5>
                                    <small>Software Development</small>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
                            <div className="team-item bg-light">
                                <div className="overflow-hidden">
                                    <img className="img-fluid" src="/img/team-2.jpg" alt="Team member 2" />
                                </div>
                                <div className="position-relative d-flex justify-content-center" style={{marginTop: "-23px"}}>
                                    <div className="bg-light d-flex justify-content-center pt-2 px-1">
                                       
                                        <a className="btn btn-sm-square btn-primary mx-1" href="#!"><i className="fab fa-linkedin"></i></a>
                                        <a className="btn btn-sm-square btn-primary mx-1" href="#!"><i className="fab fa-github"></i></a>
                                    </div>
                                </div>
                                <div className="text-center p-4">
                                    <h5 className="mb-0">Jane Smith</h5>
                                    <small>Data Science</small>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
                            <div className="team-item bg-light">
                                <div className="overflow-hidden">
                                    <img className="img-fluid" src="/img/team-3.jpg" alt="Team member 3" />
                                </div>
                                <div className="position-relative d-flex justify-content-center" style={{marginTop: "-23px"}}>
                                    <div className="bg-light d-flex justify-content-center pt-2 px-1">
                                       
                                        <a className="btn btn-sm-square btn-primary mx-1" href="#!"><i className="fab fa-linkedin"></i></a>
                                        <a className="btn btn-sm-square btn-primary mx-1" href="#!"><i className="fab fa-github"></i></a>
                                    </div>
                                </div>
                                <div className="text-center p-4">
                                    <h5 className="mb-0">David Lee</h5>
                                    <small>Digital Marketing</small>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.7s">
                            <div className="team-item bg-light">
                                <div className="overflow-hidden">
                                    <img className="img-fluid" src="/img/team-4.jpg" alt="Team member 4" />
                                </div>
                                <div className="position-relative d-flex justify-content-center" style={{marginTop: "-23px"}}>
                                    <div className="bg-light d-flex justify-content-center pt-2 px-1">
                                        
                                        <a className="btn btn-sm-square btn-primary mx-1" href="#!"><i className="fab fa-linkedin"></i></a>
                                        <a className="btn btn-sm-square btn-primary mx-1" href="#!"><i className="fab fa-github"></i></a>
                                    </div>
                                </div>
                                <div className="text-center p-4">
                                    <h5 className="mb-0">Janice Nyambura</h5>
                                    <small>Graphic Design</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Team End */}
        </>
    );
};

export default Team;